export default "__VITE_ASSET__BMty6kbY__"